/**
 * Più / meno / cestino nel carrello a tendina e nella pagina carrello,
 * a passi del multiplo MinMaxify se il prodotto ha limiti.
 * I custom element del tema perdono gli handler dopo il primo aggiornamento
 * (uno script di terze parti sovrascrive una funzione globale del bundle),
 * quindi i clic vengono gestiti qui con /cart/change.js.
 */
(function () {
  var busy = false;

  /**
   * I custom element del tema chiamano la funzione globale `a` di
   * xo-critical.min.js nel costruttore. Durante gli innerHTML (render del
   * carrello) la si rimette temporaneamente, poi si ripristina il valore
   * originale per non rompere lo script esterno.
   */
  var define = Object.defineProperty;
  var helper = function (obj, key, val) {
    key = typeof key !== 'symbol' ? key + '' : key;
    if (key in obj) define(obj, key, { enumerable: true, configurable: true, writable: true, value: val });
    else obj[key] = val;
    return val;
  };
  var desc = Object.getOwnPropertyDescriptor(Element.prototype, 'innerHTML');
  if (desc && desc.set && !Element.prototype.__respetInnerHTML) {
    Element.prototype.__respetInnerHTML = true;
    define(Element.prototype, 'innerHTML', {
      configurable: true,
      enumerable: desc.enumerable,
      get: desc.get,
      set: function (value) {
        var prev = window.a;
        if (typeof prev === 'function') return desc.set.call(this, value);
        window.a = helper;
        try {
          desc.set.call(this, value);
        } finally {
          window.a = prev;
        }
      }
    });
  }

  function lineOf(el) {
    var product = el.closest('xo-product[xo-line]');
    return product ? Number(product.getAttribute('xo-line')) : 0;
  }

  function currentQty(el) {
    var input = el.closest('xo-cart-quantity');
    input = input && input.querySelector('input[name="quantity"]');
    return input ? Number(input.value) || 0 : 0;
  }

  function lineLimits(line) {
    var fallback = { min: 1, step: 1, max: 0 };
    var mm = window.minMaxify;
    if (!mm || typeof mm.getLimitsFor !== 'function') return Promise.resolve(fallback);
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var item = cart.items && cart.items[line - 1];
        if (!item) return fallback;
        var l = mm.getLimitsFor(item) || {};
        var step = l.combine ? 1 : Number(l.multiple) || 1;
        return { min: Math.max(1, Number(l.min) || 1), step: step, max: Number(l.max) || 0 };
      })
      .catch(function () {
        return fallback;
      });
  }

  function render(mini, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById(mini.id);
    if (!fresh) return;
    var targets = mini.querySelectorAll('xo-cart-will-change[xo-unique-id]');
    if (!targets.length) {
      mini.innerHTML = fresh.innerHTML;
      return;
    }
    targets.forEach(function (target) {
      var id = target.getAttribute('xo-unique-id');
      var next = fresh.querySelector('xo-cart-will-change[xo-unique-id="' + id + '"]');
      if (next) target.innerHTML = next.innerHTML;
    });
  }

  // Lo store del tema somma le aggiunte al suo size e ridisegna il carrello dalle sue sections:
  // va allineato al carrello reale, altrimenti rimette l'HTML vecchio.
  function updateStore(cart) {
    var store = window.xoStore;
    if (store && typeof store.set === 'function') {
      store.set('xo-cart', function (state) {
        return Object.assign({}, state, {
          size: cart.item_count,
          items: cart.items,
          sections: Object.assign({}, state && state.sections, cart.sections || {})
        });
      })('respet/cartChange');
    }
    document.querySelectorAll('xo-cart-size').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  function snap(qty, limits) {
    if (qty <= 0) return 0;
    var next = Math.round(qty / limits.step) * limits.step;
    next = Math.max(next, Math.ceil(limits.min / limits.step) * limits.step);
    if (limits.max && next > limits.max) next = Math.floor(limits.max / limits.step) * limits.step;
    return next;
  }

  function containers() {
    return Array.prototype.filter.call(document.querySelectorAll('xo-cart-mini[id], xo-cart[id]'), function (el) {
      return !!el.id;
    });
  }

  function change(line, quantity) {
    busy = true;
    var boxes = containers();
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: boxes.map(function (box) {
          return box.id;
        })
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      })
      .then(function (cart) {
        boxes.forEach(function (box) {
          if (cart.sections && cart.sections[box.id]) render(box, cart.sections[box.id]);
        });
        updateStore(cart);
      })
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Errore aggiornamento carrello';
        if (window.xoToast && typeof window.xoToast.push === 'function') {
          window.xoToast.push({ content: msg, type: 'error' });
        }
      })
      .finally(function () {
        busy = false;
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('xo-cart-quantity-minus, xo-cart-quantity-plus, xo-cart-remove');
      if (!button) return;
      var box = button.closest('xo-cart-mini, xo-cart');
      if (!box || !box.id) return;
      var line = lineOf(button);
      if (!line) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy) return;

      if (button.localName === 'xo-cart-remove') {
        change(line, 0);
        return;
      }

      var qty = currentQty(button);
      var isPlus = button.localName === 'xo-cart-quantity-plus';
      busy = true;
      lineLimits(line).then(function (limits) {
        busy = false;
        var step = limits.step;
        var next = isPlus ? Math.floor(qty / step) * step + step : Math.ceil(qty / step) * step - step;
        if (isPlus && next < limits.min) next = Math.ceil(limits.min / step) * step;
        if (isPlus && limits.max && next > limits.max) return;
        if (!isPlus && next < limits.min) return;
        change(line, next);
      });
    },
    true
  );

  // Quantità digitata a mano: il tema la invia al blur così com'è, qui viene arrotondata al multiplo.
  document.addEventListener(
    'blur',
    function (event) {
      var input = event.target;
      if (!input || input.name !== 'quantity' || !input.closest) return;
      var box = input.closest('xo-cart-mini, xo-cart');
      if (!box || !box.id) return;
      var line = lineOf(input);
      if (!line) return;

      event.stopImmediatePropagation();
      var typed = Number(input.value) || 0;
      if (String(typed) === input.defaultValue) return;
      lineLimits(line).then(function (limits) {
        var next = snap(typed, limits);
        input.value = next;
        change(line, next);
      });
    },
    true
  );
})();
